<template>
  <div id="data-list-list-view" class="data-list-container">
    <h3>Change Log</h3>

    <div v-if="isMounted && changes && changes.length > 0">
      <vs-table
        ref="table"
        class="mt-8"
        v-model="selected"
        :data="changes"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
        <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            
          </div>
        </div>

        <template slot="thead">
          <vs-th sort-key="timestamp">Date</vs-th>
          <vs-th sort-key="action">Action</vs-th>
          <vs-th sort-key="userDisplayName">User</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.timestamp | formatDate }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.action }}
                </p>
              </vs-td>
              <vs-td>
                <div class="product-name font-medium truncate">
                  {{ tr.displayName }}<br/>
                  <p style="font-size:12px;">{{ tr.userId }}</p>
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
    <div v-else>
      <div class="not-data-table vs-table--not-data"> No changes </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "ChangeLog",
  components: {
  },
  props: ['source'],
  data () {
    return {
      query: '*',

      changes: [],

      selected: [],
      itemsPerPage: 100,
      isMounted: false,
    }
  },
  computed: {
    currentPage () {
      if (!this.$refs.table) {
        console.log("No table");
        return 0;
      }
      return this.$refs.table.currentx
    },
    
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.changes.length
    }
  },
  methods: {
  },
  created () {
    
  },
  mounted () {
    if (this.source)
    {
      if (Array.isArray(this.source)) {
        console.log(this.source);
        this.changes = this.source;
      } else if (this.source) {
        this.changes = this.source.entries;
      }
    }

    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>